import { handleLongText } from 'config/libraries';
import React, { Fragment } from 'react'
import { Link } from 'react-router-dom';

export const List = ({response}) => {
    
    return (
        <Fragment>
            {
                response && response.map((item, index) => {
                    return (
                        <div key={index} className="box jl_grid_layout1 blog_grid_post_style post-2957 post type-post status-publish format-standard has-post-thumbnail hentry category-inspiration tag-morning">
                            <div className="jl_grid_w">
                                <div className="jl_img_box jl_radus_e">
                                    <Link to={'/artikel/' + item.slug_artikel}>
                                        <img width={500} height={350} src={process.env.REACT_APP_SERVER_IMAGE_URL + item.gambar_artikel} className="attachment-sprasa_slider_grid_small size-sprasa_slider_grid_small wp-post-image" alt="" loading="lazy" />
                                    </Link>
                                    <span className="jl_f_cat">
                                        <Link to={'/artikel/' + item.slug_artikel} className="post-category-color-text" style={{background: '#91bd3a'}}>{item.nama_kategori_artikel}</Link>
                                    </span>
                                </div>
                                <div className="text-box">
                                    <h3>
                                        <Link to={'/artikel/' + item.slug_artikel} tabIndex={-1}>{handleLongText(item.judul_artikel, 50)}</Link>
                                    </h3>
                                    <span className="jl_post_meta">
                                        <span className="jl_author_img_w">
                                            <span className="post-date">
                                                <i className="jli-pen" />{item.created_at}
                                            </span>
                                        </span>
                                    </span>
                                    <Link to={'/artikel/' + item.slug_artikel}>
                                        <p>{handleLongText(item.sub_judul_artikel, 130)}</p>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    )
                })
            }
        </Fragment>
    )
};